// Restrictions can only enter numbers and decimal points
export function limitNumberInput(value) {
  let inputValue = value.replace(/[^\-?\d.]/g, "");
  return inputValue;
}
